import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  SUBMIT: `${cleanedFilename(__filename)}-submit`,
  CANCEL: `${cleanedFilename(__filename)}-cancel`,
};
